import { action } from 'satcheljs';

const defaultExport: () => {} = action('RESTORE_ROW_FAIL');
export default defaultExport;
